
<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> Carriers </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
        <a href="{{CarrierControllerUrl}}/0?action=download" target="_blank" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i> Download</a>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col">

        <div *ngIf="Mode==FormModes.Find">
          <div class="row" style="margin-left: 0px;">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="carrierSymbol" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Name</label>
                <div class="col-sm-9" style="margin-left: -64px; height: 0px;">
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="carrierName" maxlength="50" type="text" id="Name" name="Name" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="position: relative; top: 16px;">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="Mode==FormModes.New || Mode==FormModes.Edit" style="margin-left: 80px;">
          <!-- {{f.value | json}} -->
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row" style="margin-right: -41px">
              <div class="col-sm-6">
                <div class="form-group row">
                  <label for="carrierSymbol" class="col-sm-3 col-form-label">Name</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Name</mat-label>
                      <input matInput [(ngModel)]="Carrier.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name" />
                    </mat-form-field>
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger small">
                      <div *ngIf="name.errors.required">
                        Name is required.
                      </div>
                      <div *ngIf="name.errors.maxlength">
                        Name must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="Engine" class="col-sm-3 col-form-label">
                    Engine
                  </label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Select Engine</mat-label>
                      <mat-select [(ngModel)]="Carrier.engine" required #engine="ngModel" name="Engine">
                        <mat-option *ngFor="let eng of engines" [value]="eng.value">
                          {{eng.label}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="engine.invalid && (engine.dirty && engine.touched)" class="text-danger small">
                      <div *ngIf="engine.errors.required">
                        Engine is required.
                      </div>
                      <div *ngIf="engine.errors.maxlength">
                        Engine must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="clientName" class="col-sm-3 col-form-label">Account Number</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Account Number</mat-label>
                      <input matInput [(ngModel)]="Carrier.accountNumber" maxlength="50" #accountnumber="ngModel" type="text" id="AccountNumber" name="AccountNumber" />
                    </mat-form-field>
                    <div *ngIf="accountnumber.invalid && (accountnumber.dirty || accountnumber.touched)" class="text-danger small">
                      <div *ngIf="accountnumber.errors.maxlength">
                        Account number must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="AutoSetTrackingNumber" class="col-sm-4 col-form-label">
                    AutoSet TrackingNumber
                  </label>
                  <div class="col-sm-1">
                    <mat-checkbox class="example-margin" [checked]="Carrier.autoSetTrackingNumber" [(ngModel)]="Carrier.autoSetTrackingNumber" name="Carrier.autoSetTrackingNumber"></mat-checkbox>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="IsMultiCarrier" class="col-sm-4 col-form-label">
                    Is Multi Carrier
                  </label>
                  <div class="col-sm-1">
                    <mat-checkbox class="example-margin" [checked]="Carrier.isMultiCarrier" [(ngModel)]="Carrier.isMultiCarrier" name="Carrier.isMultiCarrier"></mat-checkbox>
                  </div>
                </div>
              </div>

              <div class="col-sm-6" [ngSwitch]="Carrier.engine">
                <div *ngSwitchCase="'FX'">
                  <div class="form-group row">
                    <label for="API Username" class="col-sm-3 col-form-label">
                      Client ID
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Client ID</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiUsername" #apiusername="ngModel" type="text" id="APIUsername" name="APIUsername" />
                      </mat-form-field>
                      <div *ngIf="apiusername.invalid && (apiusername.dirty || apiusername.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIUsername" class="col-sm-3 col-form-label">
                      Client Secret
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Client Secret</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiPassword" #apipassword="ngModel" type="text" id="APIPassword" name="APIPassword" />
                      </mat-form-field>
                      <div *ngIf="apipassword.invalid && (apipassword.dirty || apipassword.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'UPS'">
                  <div class="form-group row">
                    <label for="API Username" class="col-sm-3 col-form-label">
                      API Username
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Username</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiUsername" #apiusername="ngModel" type="text" id="APIUsername" name="APIUsername" />
                      </mat-form-field>
                      <div *ngIf="apiusername.invalid && (apiusername.dirty || apiusername.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIUsername" class="col-sm-3 col-form-label">
                      API Password
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Password</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiPassword" #apipassword="ngModel" type="text" id="APIPassword" name="APIPassword" />
                      </mat-form-field>
                      <div *ngIf="apipassword.invalid && (apipassword.dirty || apipassword.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIAccessKey" class="col-sm-3 col-form-label">
                      API Key
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Access Key</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiAccessKey" #apikey="ngModel" type="text" id="APIAccessKey" name="APIAccessKey" />
                      </mat-form-field>
                      <div *ngIf="apikey.invalid && (apikey.dirty || apikey.touched)" class="text-danger small">

                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'EP'">
                  <div class="form-group row">
                    <label for="APIAccessKey" class="col-sm-3 col-form-label">
                      API Key
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Access Key</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiAccessKey" #apikey="ngModel" type="text" id="APIAccessKey" name="APIAccessKey" />
                      </mat-form-field>
                      <div *ngIf="apikey.invalid && (apikey.dirty || apikey.touched)" class="text-danger small">

                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'BetterTrucks'">
                  <div class="form-group row">
                    <label for="API Username" class="col-sm-3 col-form-label">
                      API Username
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Username</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiUsername" #apiusername="ngModel" type="text" id="APIUsername" name="APIUsername" />
                      </mat-form-field>
                      <div *ngIf="apiusername.invalid && (apiusername.dirty || apiusername.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIUsername" class="col-sm-3 col-form-label">
                      API Password
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Password</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiPassword" #apipassword="ngModel" type="text" id="APIPassword" name="APIPassword" />
                      </mat-form-field>
                      <div *ngIf="apipassword.invalid && (apipassword.dirty || apipassword.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIAccessKey" class="col-sm-3 col-form-label">
                      API Key
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Access Key</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiAccessKey" #apikey="ngModel" type="text" id="APIAccessKey" name="APIAccessKey" />
                      </mat-form-field>
                      <div *ngIf="apikey.invalid && (apikey.dirty || apikey.touched)" class="text-danger small">

                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="TrackingFormat" class="col-sm-3 col-form-label">
                      Track Format
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Track Format</mat-label>
                        <input matInput [(ngModel)]="Carrier.trackingFormat" [required]="Carrier.autoSetTrackingNumber" maxlength="50" #trackingFormat="ngModel" type="text" id="trackingFormat" name="trackingFormat" />
                      </mat-form-field>
                      <div *ngIf="trackingFormat.invalid && (trackingFormat.dirty || trackingFormat.touched)" class="text-danger small">
                        <div *ngIf="trackingFormat.errors.required">
                          Track Format is required.
                        </div>
                        <div *ngIf="trackingFormat.errors.maxlength">
                          Please enter Track Format .
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="TrackingSuffix" class="col-sm-3 col-form-label">
                      Track Suffix
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Track Suffix</mat-label>
                        <input matInput [(ngModel)]="Carrier.trackingSuffix" [required]="Carrier.autoSetTrackingNumber" maxlength="50" #trackingSuffix="ngModel" type="text" id="TrackingSuffix" name="TrackingSuffix" />
                      </mat-form-field>
                      <div *ngIf="trackingSuffix.invalid && (trackingSuffix.dirty || trackingSuffix.touched)" class="text-danger small">
                        <div *ngIf="trackingSuffix.errors.required">
                          Track Suffix is required.
                        </div>
                        <div *ngIf="trackingSuffix.errors.maxlength">
                          Please enter Track Suffix .
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="TrackingPrefix" class="col-sm-3 col-form-label">
                      Track Prefix
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Track Prefix</mat-label>
                        <input matInput [(ngModel)]="Carrier.trackingPrefix" [required]="Carrier.autoSetTrackingNumber" maxlength="50" #trackingprefix="ngModel" type="text" id="TrackingPrefix" name="TrackingPrefix" />
                      </mat-form-field>
                      <div *ngIf="trackingprefix.invalid && (trackingprefix.dirty || trackingprefix.touched)" class="text-danger small">
                        <div *ngIf="trackingprefix.errors.required">
                          Track Prefix is required.
                        </div>
                        <div *ngIf="trackingprefix.errors.maxlength">
                          Please enter Track Prefix .
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'GLS'">
                  <div class="form-group row">
                    <label for="API Username" class="col-sm-3 col-form-label">
                      API Username
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Username</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiUsername" #apiusername="ngModel" type="text" id="APIUsername" name="APIUsername" />
                      </mat-form-field>
                      <div *ngIf="apiusername.invalid && (apiusername.dirty || apiusername.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIUsername" class="col-sm-3 col-form-label">
                      API Password
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Password</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiPassword" #apipassword="ngModel" type="text" id="APIPassword" name="APIPassword" />
                      </mat-form-field>
                      <div *ngIf="apipassword.invalid && (apipassword.dirty || apipassword.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIAccessKey" class="col-sm-3 col-form-label">
                      API Key
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Access Key</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiAccessKey" #apikey="ngModel" type="text" id="APIAccessKey" name="APIAccessKey" />
                      </mat-form-field>
                      <div *ngIf="apikey.invalid && (apikey.dirty || apikey.touched)" class="text-danger small">

                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'GORI'">
                  <div class="form-group row">
                    <label for="API Username" class="col-sm-3 col-form-label">
                      API Username
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Username</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiUsername" #apiusername="ngModel" type="text" id="APIUsername" name="APIUsername" />
                      </mat-form-field>
                      <div *ngIf="apiusername.invalid && (apiusername.dirty || apiusername.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="APIUsername" class="col-sm-3 col-form-label">
                      API Password
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Password</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiPassword" #apipassword="ngModel" type="text" id="APIPassword" name="APIPassword" />
                      </mat-form-field>
                      <div *ngIf="apipassword.invalid && (apipassword.dirty || apipassword.touched)" class="text-danger small">
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'HYPR'">
                  <div class="form-group row">
                    <label for="APIAccessKey" class="col-sm-3 col-form-label">
                      API Key
                    </label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Api Access Key</mat-label>
                        <input matInput [(ngModel)]="Carrier.apiAccessKey" #apikey="ngModel" type="text" id="APIAccessKey" name="APIAccessKey" />
                      </mat-form-field>
                      <div *ngIf="apikey.invalid && (apikey.dirty || apikey.touched)" class="text-danger small">

                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'LSO'">

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="text-center m-3">
                  <!--<button type="button" (click)="showMappingsModal()" *ngIf="this.isRateFileButtonDisplay == true" class="btn btn-sm btn-info mx-1"> <i class="fa fa-file-excel-o" aria-hidden="true"></i> Map Carrier Rate Files</button>-->
                  <button type="submit" [disabled]="f.invalid" *ngIf="Mode==FormModes.New" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
                  <button type="submit" [disabled]="f.invalid" *ngIf="Mode==FormModes.Edit" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                </div>
                <br />
              </div>
            </div>
          </form>

          <div [ngSwitch]="Carrier.engine">
            <div *ngSwitchCase="'FX' || 'UPS'">
              <!-- Child Accounts -->
              <div class="row" id="childAccountsGrid" style="margin-top: 5vh">
                <h2>Child Accounts</h2>
                <div class="row">
                  <div class="col-sm-12">

                    <div [formGroup]="childAccountsForm">
                      <ng-container formArrayName="childAccounts" class="row">
                        <ng-container *ngFor="let element of childAccounts.controls; let i = index">
                          <div formGroupName="{{i}}">
                            <div class="row">
                              <div class="col-sm-2" style="display:inline-flex">
                                <mat-form-field appearance="outline">
                                  <mat-label>Name</mat-label>
                                  <input type="text" matInput formControlName="name" />
                                </mat-form-field>
                              </div>
                              <div class="col-sm-2" style="display:inline-flex">
                                <mat-form-field appearance="outline">
                                  <mat-label>Account #</mat-label>
                                  <input type="text" matInput formControlName="accountNumber" />
                                </mat-form-field>
                              </div>

                              <div class="col-sm-2" style="display:inline-flex">

                                <div style="display: inline-flex;height:45px">
                                  <button type="button" (click)="removeChildAccount(i)" class="btn btn-danger mx-1">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                    Remove
                                  </button>
                                  <!--<button type="button" (click)="saveChildAccount(element)" class="btn btn-info mx-1">
                                    <i class="fa fa-save" aria-hidden="true"></i>
                                    Save
                                  </button>-->
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                      </ng-container>

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-2">
                    <button type="button" (click)="addChildAccount()" class="btn btn-info mx-1"> + Add Child Account</button>
                  </div>
                </div>

              </div>
            </div>
          </div>


        </div>
        <div *ngIf="Mode==FormModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="carrierSymbol" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <!-- <input [ngModel]="Carrier.name" readonly type="text" class="form-control form-control-sm" id="Name" name="Name" /> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput [ngModel]="Carrier.name" readonly type="text" id="Name" name="Name" />
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="Engine" class="col-sm-3 col-form-label">
                  Engine
                </label>
                <div class="col-sm-9">
                  <!-- <p-dropdown [options]="frequency" [(ngModel)]="model.billingFrequency" required  #billingFrequency="ngModel" id="BillingFrequency" name="BillingFrequency" [autoWidth]="true" placeholder="Select frequency" [showClear]="true"></p-dropdown> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Select Engine</mat-label>
                    <mat-select [(ngModel)]="Carrier.engine" required #engine="ngModel" name="Engine" disabled>
                      <mat-option *ngFor="let eng of engines" [value]="eng.value" disabled>
                        {{eng.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="engine.invalid && (engine.dirty && engine.touched)" class="text-danger small">
                    <div *ngIf="engine.errors.required">
                      Engine is required.
                    </div>
                    <div *ngIf="engine.errors.maxlength">
                      Engine must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="clientName" class="col-sm-3 col-form-label">Account Number</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Number</mat-label>
                    <input matInput [ngModel]="Carrier.accountNumber" readonly type="number" class="form-control form-control-sm " id="AccountNumber" name="AccountNumber" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="LastBilled" class="col-sm-3 col-form-label">
                  API Username
                </label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Account Number</mat-label>
                    <input matInput [ngModel]="Carrier.apiUsername" readonly type="text" id="APIUsername" name="APIUsername" />
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="APIUsername" class="col-sm-3 col-form-label">
                  API Password
                </label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Api Password</mat-label>
                    <input matInput [ngModel]="Carrier.apiPassword" readonly type="text" id="APIPassword" name="APIPassword" />
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="APIAccessKey" class="col-sm-3 col-form-label">
                  API Key
                </label>
                <div class="col-sm-9">
                  <!-- <input [ngModel]="Carrier.apiAccessKey" readonly type="text"  id="APIAccessKey" name="APIAccessKey" /> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Api Access Key</mat-label>
                    <input matInput [ngModel]="Carrier.apiAccessKey" readonly type="text" id="APIAccessKey" name="APIAccessKey" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmitForm()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
                <button type="button" (click)="resetForm()" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>
    <div *ngIf="Mode != FormModes.New && Mode !=FormModes.Edit && Mode !=FormModes.Del" class="row">
      <div class="col">

        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
              <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
            </ng-container>

            <ng-container matColumnDef="engine">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Engine </th>
              <td mat-cell *matCellDef="let row"> {{row.engine}} </td>
            </ng-container>

            <ng-container matColumnDef="accountNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Account Number </th>
              <td mat-cell *matCellDef="let row">{{ row.accountNumber }}  </td>
            </ng-container>

            <ng-container matColumnDef="TrackingPrefix">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> TrackingPrefix </th>
              <td mat-cell *matCellDef="let row">{{ row.trackingPrefix }}  </td>
            </ng-container>

            <ng-container matColumnDef="TrackingSuffix">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> TrackingSuffix </th>
              <td mat-cell *matCellDef="let row">{{ row.trackingSuffix }}  </td>
            </ng-container>

            <!-- <ng-container matColumnDef="MaxTracking">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> MaxTracking </th>
              <td mat-cell *matCellDef="let row">{{ row.maxTracking }}  </td>
            </ng-container>

            <ng-container matColumnDef="CurrentTracking">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CurrentTracking </th>
              <td mat-cell *matCellDef="let row">{{ row.currentTracking }}  </td>
            </ng-container> -->

            <ng-container matColumnDef="TrackingFormat">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> TrackingFormat </th>
              <td mat-cell *matCellDef="let row">{{ row.trackingFormat }}  </td>
            </ng-container>

            <ng-container matColumnDef="AutoSetTrackingNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> AutoSetTrackingNumber </th>
              <td mat-cell *matCellDef="let row">{{ row.autoSetTrackingNumber }}  </td>
            </ng-container>

            <ng-container matColumnDef="...">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
              <td mat-cell *matCellDef="let row">
                <div class="btn-group btn-group-sm">
                  <button (click)="showEdit(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                  <button (click)="showDel(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
                  <!--<button [disabled]="row.noMarkups" (click)="showRateFilesModal(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-upload" aria-hidden="true"></i></button>-->
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="CarriersCols"></tr>
            <tr mat-row *matRowDef="let row; columns: CarriersCols;"></tr>


          </table>

          <span style="position: relative; left: 40%; font-size: 13px; top: 40px;">There are {{pageLength}} records</span>
          <mat-paginator [pageIndex]="pageNumber" [pageSize]="pageSize" (page)="onPageChange($event)" [length]="pageLength" [pageSizeOptions]="[10, 50, 100]" aria-label="Select page of users"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <!--<p-paginator [rows]="10" [totalRecords]="120" [rowsPerPageOptions]="[10,20,30]"></p-paginator>-->
  </div>
</div>

<!--<ng-template #showratedFilesPopup>
  <mat-dialog-content style="display: flex; justify-content: end; margin-right: -42px;">
    <button mat-icon-button mat-dialog-close class="close-icon" (click)="close()" style=" margin-right: 28px;">
      <mat-icon style="margin-right: -30px; font-size: 20px;">close</mat-icon>
    </button>
  </mat-dialog-content>-->
<!--<div class="card card-danger">-->
<!--<div class="card-body">
  <div class="row">
    <div class="col" style="margin-left: 39px; position: relative; top: -21px;">
        <form #fileManagerForm="ngForm">
          <div class="form-group row" style="position: relative; top: -30px;">
            <label for="FileLabel" class="col-sm-3 col-form-label">Carrier Rate Name</label>
            <div class="col-sm-9 input-group-append" style="position: relative; top: -4px;">
              <mat-form-field appearance="outline">
                <mat-label>Carrier Rate Name</mat-label>
                <input matInput [(ngModel)]="FileLabel" required maxlength="50" #filelabel="ngModel" type="text" id="FileLabel" name="FileLabel" />
              </mat-form-field>-->
<!--<input [(ngModel)]="FileLabel" #filelabel="ngModel" required maxlength="50" type="text" id="FileLabel" name="FileLabel" style="border-left: 2px solid #0e0e0e !important;" />-->
<!--<div class="input-group-append">-->
<!-- <button (click)="resetFileManagerForm()" class="btn btn-sm btn-outline-secondary" type="button">Cancel</button> -->
<!--</div>-->
<!--<div *ngIf="filelabel.invalid && (filelabel.dirty || filelabel.touched)" class="text-danger small" style=" position: relative; top: -24px;">
              <div *ngIf="filelabel.errors.required">
                Label is required.
              </div>
              <div *ngIf="filelabel.errors.maxlength">
                Label must be less than 50 characters long.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row" style=" position: relative; top: -40px;">
          <label for="myfile" class="col-sm-3 col-form-label">Upload rate file</label>
          <div class="col-sm-9">
            <p-fileUpload [showUploadButton]="true"
                          (change)="upload($event)"
                          (onUpload)="onUploadComplete($event)"
                          (onBeforeSend)="onBeforeSendFile($event)"
                          (onBeforeUpload)="onBeforeUpload($event)"
                          (onSelect)="dealWithFiles($event)"
                          (onError)="onUploadError($event)"
                          name="myfile"
                          url="{{CarrierInvoiceFileControllerUrl}}"
                          accept=".xlsx, .xls,"
                          maxFileSize="2147483647"
                          [showCancelButton]="false">
            </p-fileUpload>
          </div>
        </div>
      </form>

  </div>
</div>
<div class="row" style=" position: relative; top: -20px;">
  <div class="col">
    <div class="mat-elevation-z8" style="width: 770px;
     /* height: 189px;*/
      overflow: hidden;">
      <table mat-table [dataSource]="ShowRateFileDataSource" matsort>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Carrier </th>
          <td mat-cell *matCellDef="let row">{{ row.name }}  </td>
        </ng-container>

        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Label </th>
          <td mat-cell *matCellDef="let row"> {{ row.label }} </td>
        </ng-container>

        <ng-container matColumnDef="fileOriginalName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let row">{{ row.fileOriginalName }}  </td>
        </ng-container>
        <ng-container matColumnDef="fileVersion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Ver. </th>
          <td mat-cell *matCellDef="let row"> {{ row.fileVersion }} </td>
        </ng-container>
        <ng-container matColumnDef="uploadedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
          <td mat-cell *matCellDef="let row"> {{ row.uploadedOn | date :'MM-dd-yyyy' }} </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let row">
            <a *ngIf="row.Status==2" (click)="viewFileProcessingError(row)" style="cursor:pointer">
              <span class="text-danger">{{FileParseStatus[row.status]}}</span>
              <span class="float-right text-danger"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
            </a>
            <span *ngIf="row.status!=2" [ngClass]="row.status==0?'text-primary font-weight-bold':(row.status==1?'text-success':'')">{{FileParseStatus[row.status]}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="...">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
          <td mat-cell *matCellDef="let row">
            <div class="btn-group btn-group-sm">
              <a href="{{CarrierInvoiceFileControllerUrl}}/{{row.carrierId}}/{{row.id}}?action=download" target="_blank" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
              <button (click)="viewRateFile(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-eye" aria-hidden="true"></i></button>
              <button (click)="showRateDel(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="MatRateFileDtCols"></tr>
        <tr mat-row *matRowDef="let row; columns: MatRateFileDtCols;"></tr>-->
<!-- <tr class="mat-row" *matNoDataRow>
  <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
</tr> -->
<!--</table>

        <span style="position: relative;
  left: 22%;
  top: 39px;
  font-size: 14px;">There are {{this.showratefiletabledata?.length}} records</span>

        <mat-paginator [length]="this.showratefiletabledata?.length" [pageSizeOptions]="[5, 10,50, 100]" aria-label="Select page of users"></mat-paginator>

      </div>
    </div>
  </div>
</div>-->
<!--</div>-->
<!-- <button mat-button matDialogClose="no">Cancel</button>
</ng-template>
-->
